import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_CustomTabView = _resolveComponent("CustomTabView")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.BaseControlTypeConst.VISIBLE))
    ? _withDirectives((_openBlock(), _createBlock(_component_CustomTabView, {
        key: 0,
        container: _ctx.container,
        id: _ctx.getPropertyValue(_ctx.TabViewTypeConst.ID),
        style: _normalizeStyle(_ctx.getPropertyValue(_ctx.TabViewTypeConst.STYLE)),
        class: _normalizeClass(_ctx.getPropertyValue(_ctx.TabViewTypeConst.CLASS)),
        name: _ctx.getPropertyValue(_ctx.TabViewTypeConst.NAME),
        disabled: _ctx.getPropertyBooleanValue(_ctx.TabViewTypeConst.DISABLED),
        visible: _ctx.getPropertyBooleanValue(_ctx.TabViewTypeConst.VISIBLE),
        placeholder: _ctx.getPropertyValue(_ctx.TabViewTypeConst.PLACEHOLDER),
        lazy: _ctx.getPropertyBooleanValue(_ctx.TabViewTypeConst.LAZY),
        scrollable: _ctx.getPropertyBooleanValue(_ctx.TabViewTypeConst.SCROLLABLE),
        selectOnFocus: _ctx.getPropertyBooleanValue(_ctx.TabViewTypeConst.SELECTONFOCUS),
        activeIndex: _ctx.activeIndex,
        "onUpdate:activeIndex": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeIndex) = $event)),
        tabindex: _ctx.getPropertyNumberValue(_ctx.TabViewTypeConst.TABINDEX),
        onTabChange: _ctx.changeTab
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "content"),
          (_ctx.getPropertyBooleanValue(_ctx.TabViewTypeConst.ISDYNAMIC))
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.itemTabs, (tab, index) => {
                return (_openBlock(), _createBlock(_component_TabPanel, {
                  key: tab.value2 + '_' + index
                }, {
                  default: _withCtx(() => [
                    _createCommentVNode("\r\n            <template #header>\r\n                    <div>\r\n                        <span style=\"margin-right:10px\" v-html=\"tab.label\"> </span> <i v-if=\"tab.info\"\r\n                            class=\"pi pi-info-circle\" :class=\"tab.color + '_color'\"\r\n                            v-tooltip=\"{ value: tab.info, class: 'p-message p-component p-message-info' , escape: true, }\"></i>\r\n                    </div>\r\n                    \r\n                </template>\r\n                "),
                    _createCommentVNode("\r\n                <FormBuilder  :container=\"container\" :componentId=\"tab.value2\" :applicationId=\"tab.value\" :applicationVersion=\"tab.value1\" />\r\n                ")
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */))
              }), 128 /* KEYED_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ]),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["container", "id", "style", "class", "name", "disabled", "visible", "placeholder", "lazy", "scrollable", "selectOnFocus", "activeIndex", "tabindex", "onTabChange"])), [
        [_directive_tooltip, _ctx.getPropertyValue(_ctx.TabViewTypeConst.TOOLTIP)]
      ])
    : _createCommentVNode("v-if", true)
}